import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BlockImageReport } from './Pages';

export const BlockImageReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={BlockImageReport} />
       
    </Fragment>
)